
import React from 'react';

interface PlaybackSpeedControlProps {
  speed: number;
  onSpeedChange: (s: number) => void;
  disabled?: boolean;
}

export const PlaybackSpeedControl: React.FC<PlaybackSpeedControlProps> = ({ speed, onSpeedChange, disabled = false }) => {
  const PRESETS = [0.5, 0.75, 1.0];

  return (
    <div className={`flex flex-col gap-2 p-4 bg-black/40 rounded-2xl border border-white/5 transition-opacity ${disabled ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
      <div className="flex items-center justify-between">
        <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest">Vitesse (Rate)</span>
        <span className="text-[10px] font-mono font-black text-smart-accent">{speed.toFixed(2)}x</span>
      </div>

      <div className="flex items-center gap-2">
        {PRESETS.map(p => (
          <button
            key={p}
            onClick={() => onSpeedChange(p)}
            className={`flex-1 py-1.5 rounded-lg text-[9px] font-black transition-all border ${
              Math.abs(speed - p) < 0.01 
                ? 'bg-smart-accent text-white border-smart-accent' 
                : 'bg-white/5 text-slate-400 border-transparent hover:bg-white/10'
            }`}
          >
            {p}x
          </button>
        ))}
      </div>

      <input 
        type="range" 
        min="0.5" 
        max="1.0" 
        step="0.05" 
        value={speed}
        onChange={(e) => onSpeedChange(parseFloat(e.target.value))}
        className="w-full h-1 bg-white/10 rounded-full appearance-none cursor-pointer accent-white mt-1"
      />
      
      <p className="text-[7px] text-slate-600 font-medium italic text-center mt-1">
        Ralenti : pour écouter les détails (le pitch peut changer).
      </p>
    </div>
  );
};
